import React from "react";
import { scrollToClass } from "../utils/scroll";
const BanerPhoto = () => {


    return(
    <div className="photo-container">
        <div className="header-photo-container">
            <h1>Dostawy i odbiory ziemi, piasku i kruszywa <br/>  Zielona Góra</h1>
            <button onClick={() => scrollToClass(`calendary-section`,10)} id="reservation-now-button"><h3>Rezerwuj teraz!</h3></button>
            
        </div>
        <img width="4718" height="1648" src="photos/baner2.webp" alt="Zdjęcie koparko-ładowarka"></img>
    </div>
    )


}

export default BanerPhoto